// The booking someone started on Book a visit and left unsent (QA-723), as this tab last had it: in
// memory only (never storage), as the review queue is kept (review/queue-cache.ts), so going to Setup
// to add a job type and coming back finds it as it was. A customer's details don't outlive the page,
// and signing out forgets it. Kept apart from Book.tsx so the header can forget it without the screen.

import type { Draft } from './book-model.ts';

/** The form as it was left: what was picked and typed, and the customer field's text. */
export interface KeptBooking {
  draft: Draft;
  query: string;
}

let kept: { tenant: string; b: KeptBooking } | null = null;
export const keptBooking = (tenant: string): KeptBooking | null => (kept?.tenant === tenant ? kept.b : null);
export const keepBooking = (tenant: string, b: KeptBooking): void => {
  kept = { tenant, b };
};
export const forgetBooking = (): void => {
  kept = null;
};
